import { render, staticRenderFns } from "./org-user-edit.vue?vue&type=template&id=4788f2d7&scoped=true&"
import script from "./org-user-edit.vue?vue&type=script&lang=js&"
export * from "./org-user-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4788f2d7",
  null
  
)

export default component.exports